import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaTools, WeaErrorPage, WeaLocaleProvider, WeaTable} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
const { ls } = WeaTools;
import EHeader from '../common/EHeader';
import FooterMore from "../common/FooterMore";
let Base64 = ecCom.WeaTools.Base64;
import {formatData, NoRightCom} from '../../util/common';
import NewNoticeCom from './NewNotice';
import MarqueeCom from '../common/MarqueeCom';
//元素组件
class NewNotice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edata: null,
            refresh: false,
        }
        this.handleEData = this.handleEData.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    handleDelete(){
        this.setState({
            edata: null,
        });
        ls.set('edata-'+this.props.config.params.eid, null);
    }
    handleRefresh(){
        this.setState({
            refresh: true,
        });
        this.handleEData(this.props.config.params);
    }
    handleEData(params){
        const { eid, api } = params;
        WeaTools.callApi(api || '/api/portal/element/newnotice', 'POST', {...params}).then(result=> {
            ls.set('edata-'+eid, result);
            window.elements_more_params[eid] = {canAddNotice: result.esetting && result.esetting.canAddNotice,isRouteUrl: true, createMethod: result.esetting && result.esetting.createMethod || '1', paramsStr: result.esetting && result.esetting.createMethod == '2' ? ("&jsonstr=" + Base64.encode(result.esetting.more.toString())) : ''};
            this.setState({
                edata: result,
                refresh: false,
            });
       });
    }
    componentDidMount(){
        const { config = {} } = this.props;
        const { params = {} } = config;
        const { eid } = params;
        const edata = ls.getJSONObj(`edata-${eid}`);
        if (config.islsdata && edata) {
            this.setState({ edata });
        } else {
            this.handleEData(params);
        }
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            this.handleEData(nextProps.config.params);
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config)
    }
    render() {
        const { edata, refresh } = this.state;
        if(isEmpty(edata)) return <div/>;
        const { esetting = {} } = edata;
        const { eScrollDirection={}, scrollSpeed, noticeIsText } = esetting;
        const { config, fontSizeMp } = this.props;
        if(!config || !edata) return <div/>;
        const { isHasRight, item } = config;
        const { eid, ebaseid, contentview, style } = item;
        const { style: style1= {} } = contentview;
        let EContentHtml = <div/>;
        let scolltype = 'none';
        if(eScrollDirection.selected){
            switch (eScrollDirection.selected) {
                case '1':
                    scolltype = 'up';
                    break;
                case '2':
                    scolltype = 'right';
                    break;
                case '3':
                    scolltype = 'down';
                    break;
                case '4':
                    scolltype = 'left';
                    break;
                default:
                    scolltype = 'none';
            }
        }

        if(isHasRight){
            if(!isEmpty(edata)){
                // EContentHtml = <MarqueeCom tabdata={edata} eid={eid} scolltype={scolltype} scrollSpeed={scrollSpeed}><NewNoticeCom eid={eid} data={edata.data} esetting={edata.esetting} handleRefresh={this.handleRefresh} scolltype={scolltype} scrollSpeed={scrollSpeed}/></MarqueeCom>;
                EContentHtml = <NewNoticeCom ecId={`${this && this.props && this.props.ecId || ''}_NewNoticeCom@spoj02`} eid={eid} data={edata.data} esetting={edata.esetting} handleRefresh={this.handleRefresh} scolltype={scolltype} scrollSpeed={scrollSpeed}/>;
            }
        }else{
            EContentHtml = <NoRightCom ecId={`${this && this.props && this.props.ecId || ''}_NoRightCom@7tpxus`}/>
        }
        return <div className="item"
                    style={style}
                    id={`item_${eid}`} 
                    data-eid={eid} data-ebaseid={ebaseid} 
                    data-needRefresh={item.needRefresh} 
                    data-cornerTop={item.cornerTop} 
                    data-cornerTopRadian={item.cornerTopRadian}
                    data-cornerBottom={item.cornerBottom} 
                    data-cornerBottomRadian={item.cornerBottomRadian}>
                    <EHeader ecId={`${this && this.props && this.props.ecId || ''}_EHeader@4p5xm8`} config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                    <div className="setting" id={`setting_${eid}`}></div>
                    <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%'}}>
                        <div className="ant-spin-container"></div>
                        <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                            <div id={`tabcontant_${eid}`} className="newNotice-tabcontent">
                                <Spin ecId={`${this && this.props && this.props.ecId || ''}_Spin@h6ougt`} spinning={refresh}>{EContentHtml}</Spin>
                            </div>
                        </div>
                        <div style = {{textAlign:'right'}} id={`footer_${eid}`}><FooterMore ecId={`${this && this.props && this.props.ecId || ''}_FooterMore@pd4ggp`} config={this.props.config}/></div>
                    </div>
            </div>;
    }
}
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@zb8pkd`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
NewNotice = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(NewNotice);
export default NewNotice;






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/newnotice/index.js